import React, { useState , useEffect } from 'react';
import { useGetRandomNewsQuery } from '../Store/Features/NewsletterAPI';
import { useRouter } from 'next/router';
import Link from 'next/link'
import Image from 'next/image';
import SectionHeading from '../Common/SectionHeading'

export default function RecentArticle({event, slugPrefix}) {
  // const { data: posts, error, isLoading } = useGetRandomNewsQuery(`/conference/filtered_list/` + (confType ? confType : 'asco'));
  const { data: posts, error, isLoading } = useGetRandomNewsQuery(`/conference/filtered_list/` + (event ? event : 'asco'));

  const [hoveredCard, setHoveredCard] = useState(2);

  const [filterData , setFilterdData] = useState([])

  const router = useRouter()

  const [baseUrl , setBaseUrl] = useState('')

  useEffect(() => {
    const currentPath = router.asPath;
    const pathSegments = currentPath.split('/');
    const newPath = pathSegments.slice(0, -1).join('/');
    setBaseUrl(newPath)
  }, [router.asPath]);

  useEffect(() => {
    const mappedData = posts?.map(post => post).slice(0, 3);
    setFilterdData(mappedData);
  }, [posts]);

  const [activeIndex, setActiveIndex] = useState(1);

  const handleHover = (index) => {
    const relatedItems = document.querySelectorAll('.relatedCardItems');
    relatedItems?.forEach((item, i) => {
      if (i === index) {
        item?.querySelector('.img').classList.add('active');
      } else {
        item?.querySelector('.img').classList.remove('active');
      }
    });

    const relatedCardContent = document.querySelectorAll('.relatedCardContent');
    relatedCardContent.forEach((content, i) => {
      if (i === index) {
        content.style.backgroundColor = '#000';
        // content.style.color = '#000';
        content.querySelectorAll('h6, p, a').forEach((elem) => {
          elem.style.color = '#fff';
        });
        content.querySelector('.relatedWhiteBtn').style.color = '#000';
      } else {
        content.style.backgroundColor = '#f4f4f4';
        content.querySelectorAll('h6, p, a').forEach((elem) => {
          elem.style.color = '#000';
        });
      }
    });
  };
  console.log(filterData);
  return (

    // <div className="grid grid-cols-12 gap-4 mt-10">
    //   {filterData?.map((card) => (
    //     <div
    //       key={card._id}
    //       className={`col-span-${hoveredCard === card._id || hoveredCard === null ? '6' : '3'} relative overflow-hidden bg:[#f4f4f4]`}
    //       onMouseEnter={() => setHoveredCard(card._id)}
    //       onMouseLeave={() => setHoveredCard(card._id)}
    //     >
    //       <div className="flex group">
    //         <div
    //           className={`w-${hoveredCard === card._id || hoveredCard === null ? '60' : '0' }  overflow-hidden transition-transform transform`}
    //           style={{ display: hoveredCard === card._id || hoveredCard === null ? 'block' : 'none' }}
    //         >
    //           <Image
    //             src={process.env.IMG_CDN + card.image}
    //             alt={card.image_alt}
    //             width={2000}
    //             height={2000}
    //             className={`w-full opacity-0 transition-opacity ${
    //               hoveredCard === card._id || hoveredCard === null ? 'opacity-100' : 'opacity-0'
    //             }`}
                
    //           />
    //         </div>
    //         <div className= {`w-${hoveredCard === card._id || hoveredCard === null ? '1/2' : 'full'} bg-[#f4f4f4] p-8 h-[400px]`}>
    //           <p className='text-center bg-white rounded-t-none rounded-b-none rounded-r-full rounded-l-none p-[8px 17px 9px] ml-0 mt-[10px] text-base br-[0px 15px 15px 0px]'>{
    //             card.targets?.map((data , index)=>{
    //               return <span key={index}>{data.value}</span>
    //             })
    //           }</p>
    //           <h2 className="mb-4 text-lg font-semibold line-clamp-2">{card.title}</h2>
    //           <p className="mb-4 text-base line-clamp-3">{card.short_description}</p>
    //           <p className="text-base mt-28">
    //             <Link href={baseUrl + '/' +card.slug}>
    //             <span className='uppercase pt-[10px] pr-[30px] border-t-[2px] border-t-[#1b9d3c]'>
    //               Explore More
    //             </span>
    //             </Link>
    //           </p>
    //         </div>
    //       </div>
    //     </div>
    //   ))}
    // </div>
    <>
      <div className="w-11/12 mx-auto my-6 xl:max-w-screen max-w-screen-2xl lg:my-12">
        <SectionHeading 
          title="Recent Articles"
        />
        <div className='gap-4 my-4'>
          <section className="flex flex-col justify-between relatedCardSection lg:flex-row">
            {filterData?.map((item, index) => (
              <div
                key={index}
                className={`relatedCardItems ${index === 1 ? 'active' : ''}`}
                onMouseEnter={() => handleHover(index)}
                onMouseLeave={() => handleHover(1)}
              >
                <div
                  className={index === 1 ? 'img active' : 'img'}
                  style={{
                    backgroundImage: `url('${process.env.IMG_CDN + item?.image}')`
                  }}
                />
                <div className="xl:w-[320px] w-full relatedCardContent">
                  <p className="delve-p relatedWhiteBtn">
                    <span>Analysis</span>
                  </p>
                  <h6 className="delve-subheading line-clamp-2">
                    {item?.title}
                  </h6>
                  <p className="delve-p line-clamp-3">{item?.short_description}</p>
                  {/* <Link href={baseUrl + '/'+item?.slug} className="mt-auto readMore delve-p">
                    <span className="relatedBtn">Explore More</span>
                  </Link> */}
                  {
                    event === 'asco' ?
                    <Link className="mt-auto readMore delve-p" href={process.env.APP_URL + `/asco-conference` + `/${slugPrefix}/` + item?.slug}>
                      <span className="relatedBtn">Explore More</span>
                    </Link>
                    :
                    event === 'esmo' ?
                    <Link className="mt-auto readMore delve-p" href={process.env.APP_URL + `/esmo-conference` + '-' + `${item?.years[0]?.value}` + `/${slugPrefix}/` + item?.slug}>
                      <span className="relatedBtn">Explore More</span>
                    </Link> :
                    event === 'aacr' ?
                    <Link className="mt-auto readMore delve-p" href={process.env.APP_URL + `/aacr-annual-meeting` + `/${event + '-' + `${item?.years[0]?.value}`}/` + item?.slug}>
                      <span className="relatedBtn">Explore More</span>
                    </Link>
                    :
                    <Link className="mt-auto readMore delve-p" href={process.env.APP_URL + `/${event + '-conference'}/` + `${event + '-' + `${item?.years[0]?.value}`}/` + item?.slug}>
                      <span className="relatedBtn">Explore More</span>
                    </Link>
                  }
                </div>
              </div>
            ))}
          </section>
        </div>
      </div>
    </>
  );
}